// extracted by mini-css-extract-plugin
module.exports = {"category":"features-module--category--1OjOw"};